import { capitalize } from '@attain-apps/string-utils'
import { TypeChecker } from '@attain-apps/type-guards'

import type { Transformer } from './transformer'

export type MethodName<TOutputType extends string> =
  `get${Capitalize<TOutputType>}From`
export namespace MethodName {
  export const isMethodName = TypeChecker.Factory.custom(
    (val: unknown): val is MethodName<string> =>
      typeof val === 'string' && /^get[A-Z].+From$/.test(val),
    { typeDescription: 'AtnTransformer.MethodName' },
  )

  export type From<TTransformer extends Transformer.Constraint> =
    TTransformer extends Transformer<infer TOutputType, any, any>
      ? Extract<keyof TTransformer, MethodName<TOutputType>>
      : never

  export function from<TOutputType extends string>(
    outType: TOutputType,
  ): MethodName<TOutputType>
  export function from<TTransformer extends Transformer.Constraint>(
    transformer: TTransformer,
  ): MethodName.From<TTransformer>[]
  export function from(
    source: string | Transformer.Constraint,
  ): MethodName<string> | MethodName<string>[] {
    if (typeof source === 'string') {
      return `get${capitalize(source)}From`
    }
    return Object.keys(source).filter(isMethodName)
  }
}
